import gql from 'graphql-tag';

export const typeDefs = gql`
  """
  A single place for all Site Search functionality.
  """
  type SearchResultHighlightFragment {
    """
    The highlighted text.
    """
    value: String
    """
    Whether the text is highlighted.
    """
    isHighlighted: Boolean
  }
  """
  A search result image object.
  """
  type SearchResultImage {
    """
    The URL of the image.
    """
    url: String
  }

  """
  The result for a single page.
  """
  type SearchResult {
    """
    The title of the search result.
    """
    title: String
    """
    The description for the result.
    """
    description: String
    """
    A text excerpt from the search result.
    """
    snippet: String
    """
    A list of fragments of the snippet, which can be highlighted.
    """
    highlightedSnippet: [SearchResultHighlightFragment]
    """
    The URL for viewing this result.
    """
    pageUrl: String
    """
    The collection name is hard coded to "page".
    """
    collectionName: String
    """
    The Open Graph Image of the result.
    """
    image: SearchResultImage
  }

  """
  The result for a single page search result.
  """
  type SearchResultEdge {
    """
    The cursor for the current node.
    """
    cursor: String
    """
    The details of the requested document.
    """
    node: SearchResult
  }

  """
  The result for all page search results.
  """
  type SearchResultConnection {
    """
    Number of search results in the response.
    """
    count: Int
    """
    The list of search results.
    """
    edges: [SearchResultEdge]
  }

  type Query {
    """
    Site Search data is stored is Elasticsearch. When a site is published, a site indexing job is triggered. Dynamic and
    static page content are indexed.
    """
    search(
      """
      The text to search for on the site.
      """
      query: String
      """
      The hostname of the site publish target.
      """
      publishTarget: String
      """
      Optional flag to return a random sampling of results.
      """
      random: Boolean
      """
      The number of characters after which the result snippet is truncated.
      """
      snippetLength: Int
      """
      Only return results after given cursor.
      """
      after: String
      """
      Number of results to return.
      """
      first: Int
    ): SearchResultConnection!
  }
`;
